import { PeopleAlt } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import UsersAndGroupsTab from "./UsersAndGroupsTab";

export const UsersAndGroups = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{
            padding: '15px 30px',
            backgroundColor: '#F7F8FA',
            height: '100%'
        }}>
           <Box sx={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '1px solid #0000001A',
                borderRadius: '4px',
                padding: '30px',
                height: '100%'
            }}>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: '16px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: "row",
                        gap: '12px',
                    }}>
                        <PeopleAlt sx={{
                            color: "#22638D",
                            alignSelf: 'self-end',
                            width: '27px',
                            height: '27px',
                        }} widths='24px' height='24px'/>
                        <Typography sx={{
                            font: 'normal normal 600 20px/27px Segoe UI',
                            letterSpacing: '0px',
                            color: '#2D2D2D',
                        }}>{t('AdminConsole.UsersAndGroups')}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={{
                            font: 'normal normal normal 14px/21px Segoe UI',
                            letterSpacing: '0px',
                            color: '#969696',
                        }}>{t('AdminConsole.EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions')}</Typography>
                    </Box>
                    <UsersAndGroupsTab />
                </Box>
            </Box>
        </Box>
    )
}

